import { useEffect, useState } from 'react';
import getColumnClass from '../utils/getColumnClass';
import CardSkeleton from './Common/CardSkeleton';
import GridControls from './Common/GridControls';
import ProductCard from './Shop/ProductCard';
const SearchProductList = ({ searchData }) => {
  const [products, setProducts] = useState([]);
  const [displayedProducts, setDisplayedProducts] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [sortCriteria, setSortCriteria] = useState('0');
  const [gridSize, setGridSize] = useState(() => {
    const storeGridZize = localStorage.getItem('SearchGridSize');
    return storeGridZize ? parseInt(storeGridZize, 10) : 4;
  });
  useEffect(() => {
    localStorage.setItem('SearchGridSize', gridSize.toString());
  }, [gridSize]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    if (searchData && searchData.length > 0) {
      setProducts(searchData);
      setDisplayedProducts(sortProducts(searchData));
      setIsLoading(false);
    } else {
      setIsLoading(false); // Set loading to false if searchData is not available
    }
  }, [searchData]);
  useEffect(() => {
    setDisplayedProducts(sortProducts([...products]));
  }, [sortCriteria, products]);
  const handleSortChange = (event) => {
    setSortCriteria(event.target.value);
  };
  const sortProducts = (products) => {
    switch (sortCriteria) {
      case 'featured':
        return products.sort((a, b) => b.is_featured - a.is_featured);
      case 'new_arrival':
        return products.sort(
          (a, b) => new Date(b.time_stamp) - new Date(a.time_stamp)
        );
      case 'biggest_discount':
        return products.sort((a, b) => {
          const maxDiscountA = Math.max(
            ...a.varients.map((v) => v.discount_percent)
          );
          const maxDiscountB = Math.max(
            ...b.varients.map((v) => v.discount_percent)
          );
          return maxDiscountB - maxDiscountA;
        });
      case 'low_to_high':
        return products.sort((a, b) => {
          const minPriceA = Math.min(...a.varients.map((v) => v.final_price));
          const minPriceB = Math.min(...b.varients.map((v) => v.final_price));
          return minPriceA - minPriceB;
        });
      case 'high_to_low':
        return products.sort((a, b) => {
          const minPriceA = Math.min(...a.varients.map((v) => v.final_price));
          const minPriceB = Math.min(...b.varients.map((v) => v.final_price));
          return minPriceB - minPriceA;
        });
      default:
        return products;
    }
  };
  return (
    <>
      <div className="filter-bar bg-white border rounded-3 px-sm-4 px-2 py-2 mb-4 shadow-sm">
        <div className="row align-items-center gy-2">
          {/* Sort Dropdown */}
          <div className="col-sm-8 col-6">
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold text-muted d-none d-sm-block">
                Sort by:
              </span>
              <select
                className="form-select form-select-sm w-auto shadow-none border-0 bg-light px-3 py-2 rounded-2 sorted_by"
                name="sorted_by"
                onChange={handleSortChange}
              >
                <option value="0">Default</option>
                <option value="featured">Featured</option>
                <option value="new_arrival">New Arrival</option>
                <option value="biggest_discount">Biggest Discount</option>
                <option value="low_to_high">Price: Low to High</option>
                <option value="high_to_low">Price: High to Low</option>
              </select>
            </div>
          </div>

          {/* Products Count */}
          <div className="col-sm-4 col-6 text-end">
            <span className="text-muted small">
              Total Products:
              <strong className="purple-color">{products.length}</strong>
            </span>
          </div>
        </div>
      </div>
      <GridControls
        gridSize={gridSize}
        setGridSize={setGridSize}
        windowWidth={windowWidth}
      />
      <div className="row">
        {error && <em className="form_error">{error}</em>}
        {isLoading && <CardSkeleton cards={8} />}
        {displayedProducts.length > 0 ? (
          displayedProducts.map((product) => (
            <div
              className={`${getColumnClass(gridSize, windowWidth)} p-2`}
              key={product.product_id}
            >
              <ProductCard key={product.product_id} product={product} />
            </div>
          ))
        ) : (
          <div className="col-12 text-center">
            <div className="d-inline-block">
              <i className="fas fa-box-open fa-2x purple-color mb-3"></i>
              <h5 className="mb-1">No Products Found</h5>
              <p className="text-muted mb-0">
                Try adjusting your filters or search keywords.
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default SearchProductList;
